<template>
  <div class="container">
    <h2>{{ page.Title }}</h2>
    <div v-if="page.Content" v-html="page.Content"></div>
    <div class="row">
      <div class="col-lg-7" v-if="!page.Questions[1].Value">
        <!-- employment_places call api Change ANSÆTTELSESFORM-->
        <DoTypeAlong
          v-model="page.Questions[0].Value"
          :value="page.Questions[0].Value"
          :id="page.Questions[0].QID"
          :config="page.Questions[0].Config"
          :options="page.Questions[0].Options"
          @getNewData="apiGetSelectOptions('employment_places')"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6">
        <!-- no_workplace -->
        <DoCheckbox
          v-model="page.Questions[1].Value"
          :value="page.Questions[1].Value"
          :id="page.Questions[1].QID"
          :config="page.Questions[1].Config"
          :options="page.Questions[1].Options"
          @doChange="resetWork"
        />
      </div>
    </div>
    <AppFlowTransition class="px-md-4 pb-4 pt-2">
      <div
        class="row boxed pt-2"
        key="hasNoWorkplace"
        v-if="page.Questions[1].Value"
      >
        <div class="col-md-6">
          <!-- work_name -->
          <doInput
            v-model="page.Questions[31].Value"
            :value="page.Questions[31].Value"
            :id="page.Questions[31].QID"
            :config="page.Questions[31].Config"
          />
        </div>
        <div class="col-lg-6">
          <!-- employment_area  call api Change ANSÆTTELSESFORM-->
          <DoSelect
            v-model="page.Questions[2].Value"
            :value="page.Questions[2].Value"
            :id="page.Questions[2].QID"
            :config="page.Questions[2].Config"
            :options="page.Questions[2].Options"
            @getNewData="apiGetSelectOptions('employment_area')"
          />
        </div>
        <div class="col-12"></div>
        <div class="col-md-4">
          <!-- att_address -->
          <doInput
            v-model="page.Questions[3].Value"
            :value="page.Questions[3].Value"
            :id="page.Questions[3].QID"
            :config="page.Questions[3].Config"
          />
        </div>
        <div class="col-md-5">
          <!-- work_address -->
          <doInput
            v-model="page.Questions[4].Value"
            :value="page.Questions[4].Value"
            :id="page.Questions[4].QID"
            :config="page.Questions[4].Config"
          />
        </div>
        <div class="col-lg-1 col-sm-3 col-4">
          <!-- work_street_number -->
          <doInput
            v-model="page.Questions[5].Value"
            :value="page.Questions[5].Value"
            :id="page.Questions[5].QID"
            :config="page.Questions[5].Config"
          />
        </div>
        <div class="col-lg-1 col-sm-3 col-4">
          <!-- work_floor -->
          <doInput
            v-model="page.Questions[6].Value"
            :value="page.Questions[6].Value"
            :id="page.Questions[6].QID"
            :config="page.Questions[6].Config"
          />
        </div>
        <div class="col-lg-1 col-sm-3 col-4">
          <!-- work_door -->
          <doInput
            v-model="page.Questions[7].Value"
            :value="page.Questions[7].Value"
            :id="page.Questions[7].QID"
            :config="page.Questions[7].Config"
          />
        </div>
        <div class="col-12"></div>
        <div class="col-md-8">
          <!-- work_placename -->
          <doInput
            v-model="page.Questions[8].Value"
            :value="page.Questions[8].Value"
            :id="page.Questions[8].QID"
            :config="page.Questions[8].Config"
          />
        </div>
        <div class="col-12"></div>
        <div class="col-md-3 hide">
          <!-- work_country_code -->
          <doCountry
            autocomplete="off"
            v-model="page.Questions[9].Value"
            :value="page.Questions[9].Value"
            :id="page.Questions[9].QID"
            :config="page.Questions[9].Config"
            @getNewData="setCountry"
          />
        </div>
        <div class="col-md-3 col-6" v-if="hasDKAddressNoWork()">
          <!-- Zip -->
          <DoZipCode
            v-model="page.Questions[10].Value"
            :value="page.Questions[10].Value"
            :id="page.Questions[10].QID"
            :config="page.Questions[10].Config"
            :options="page.Questions[10].Options"
            @input="setCity(10)"
          />
        </div>
        <div class="col-md-6" v-if="hasDKAddressNoWork()">
          <!-- City -->
          <DoCity
            v-model="page.Questions[11].Value"
            :value="page.Questions[11].Value"
            :id="page.Questions[11].QID"
            :config="page.Questions[11].Config"
            :options="page.Questions[11].Options"
            @input="setZip(11)"
          />
        </div>
        <div class="col-md-3 col-6" v-if="!hasDKAddressNoWork()">
          <!-- Zip -->
          <DoInput
            v-model="page.Questions[33].Value"
            :value="page.Questions[33].Value"
            :id="page.Questions[33].QID"
            :config="page.Questions[33].Config"
          />
        </div>
        <div class="col-md-6" v-if="!hasDKAddressNoWork()">
          <!-- City -->
          <DoInput
            v-model="page.Questions[34].Value"
            :value="page.Questions[34].Value"
            :id="page.Questions[34].QID"
            :config="page.Questions[34].Config"
          />
        </div>
        <div class="col-md-8">
          <!-- work_country -->
          <doSelect
            v-model="page.Questions[12].Value"
            :value="page.Questions[12].Value"
            :id="page.Questions[12].QID"
            :config="page.Questions[12].Config"
            :options="countryOptions"
            @input="setCountryCode"
          />
          <!-- <doInput
            v-model="page.Questions[12].Value"
            :value="page.Questions[12].Value"
            :id="page.Questions[12].QID"
            :config="page.Questions[12].Config"
          /> -->
        </div>
        <div class="col-md-5" v-if="this.page.Questions[9].Value === 'DK'">
          <!-- work_cvr -->
          <doInput
            v-model="page.Questions[13].Value"
            :value="page.Questions[13].Value"
            :id="page.Questions[13].QID"
            :config="page.Questions[13].Config"
          />
        </div>
        <div class="col-md-7" v-if="this.page.Questions[9].Value === 'DK'">
          <!-- work_cvr_get -->
          <DoExtLink
            :value="page.Questions[32].Value"
            :id="page.Questions[32].QID"
            :config="page.Questions[32].Config"
          />
        </div>
      </div>
    </AppFlowTransition>
    <div class="row">
      <div class="col-lg-4 col-md-6">
        <!-- work_start_date -->
        <DoDate
          v-model="page.Questions[14].Value"
          :value="page.Questions[14].Value"
          :id="page.Questions[14].QID"
          :config="page.Questions[14].Config"
        />
      </div>
      <div class="col-md-6">
        <!-- work_title Måske vi har brug for at der også er en option select-->
        <doInput
          v-model="page.Questions[15].Value"
          :value="page.Questions[15].Value"
          :id="page.Questions[15].QID"
          :config="page.Questions[15].Config"
        />
      </div>
      <div
        class="col-md-6"
        v-if="page.Questions[16].Options.length"
        v-show="page.Questions[16].Options.length > 1"
      >
        <!-- employment_form -->
        <DoWorkSelect
          v-model="page.Questions[16].Value"
          :value="page.Questions[16].Value"
          :id="page.Questions[16].QID"
          :config="page.Questions[16].Config"
          :options="page.Questions[16].Options"
          @getNewData="apiGetSelectOptions('employment_form')"
        />
      </div>
      <div class="col-12"></div>

      <div
        class="col-md-6"
        v-if="page.Questions[17].Options.length"
        v-show="page.Questions[17].Options.length > 1"
      >
        <!-- employment_category  call api Change employment_timeofweek, employment_union_department-->
        <DoWorkSelect
          v-model="page.Questions[17].Value"
          :value="page.Questions[17].Value"
          :id="page.Questions[17].QID"
          :config="page.Questions[17].Config"
          :options="page.Questions[17].Options"
          @getNewData="apiGetSelectOptions('employment_category')"
        />
      </div>
      <div class="col-12"></div>
      <div
        class="col-md-6"
        v-if="page.Questions[19].Options.length"
        v-show="page.Questions[19].Options.length > 1"
      >
        <!-- employment_union_department -->
        <DoWorkSelect
          v-model="page.Questions[19].Value"
          :value="page.Questions[19].Value"
          :id="page.Questions[19].QID"
          :config="page.Questions[19].Config"
          :options="page.Questions[19].Options"
          @getNewData="apiGetSelectOptions('employment_timeofweek')"
        />
      </div>
      <div class="col-12"></div>
      <div
        class="col-md-6"
        v-if="page.Questions[18].Options.length"
        v-show="page.Questions[18].Options.length > 1"
      >
        <!-- employment_timeofweek -->
        <DoWorkSelect
          v-model="page.Questions[18].Value"
          :value="page.Questions[18].Value"
          :id="page.Questions[18].QID"
          :config="page.Questions[18].Config"
          :options="page.Questions[18].Options"
        />
      </div>
      <div class="col-12"></div>
      <div class="col-md-6">
        <!-- no_work_address -->
        <DoCheckbox
          v-model="page.Questions[20].Value"
          :value="page.Questions[20].Value"
          :id="page.Questions[20].QID"
          :config="page.Questions[20].Config"
          :options="page.Questions[20].Options"
        />
      </div>
    </div>
    <AppFlowTransition class="px-4 pb-4 pt-2 boxed">
      <div
        class="row boxed"
        key="hasOtherWorkplace"
        v-if="page.Questions[20].Value"
      >
        <div class="col-md-4">
          <!-- work_other_att_address -->
          <doInput
            v-model="page.Questions[21].Value"
            :value="page.Questions[21].Value"
            :id="page.Questions[21].QID"
            :config="page.Questions[21].Config"
          />
        </div>
        <div class="col-md-5">
          <!-- work_other_address -->
          <doInput
            v-model="page.Questions[22].Value"
            :value="page.Questions[22].Value"
            :id="page.Questions[22].QID"
            :config="page.Questions[22].Config"
          />
        </div>
        <div class="col-lg-1 col-sm-3 col-4">
          <!-- work_other_street_number -->
          <doInput
            v-model="page.Questions[23].Value"
            :value="page.Questions[23].Value"
            :id="page.Questions[23].QID"
            :config="page.Questions[23].Config"
          />
        </div>
        <div class="col-lg-1 col-sm-3 col-4">
          <!-- work_other_floor -->
          <doInput
            v-model="page.Questions[24].Value"
            :value="page.Questions[24].Value"
            :id="page.Questions[24].QID"
            :config="page.Questions[24].Config"
          />
        </div>
        <div class="col-lg-1 col-sm-3 col-4">
          <!-- work_other_door -->
          <doInput
            v-model="page.Questions[25].Value"
            :value="page.Questions[25].Value"
            :id="page.Questions[25].QID"
            :config="page.Questions[25].Config"
          />
        </div>
        <div class="col-12"></div>
        <div class="col-md-8">
          <!-- work_other_placename -->
          <doInput
            v-model="page.Questions[26].Value"
            :value="page.Questions[26].Value"
            :id="page.Questions[26].QID"
            :config="page.Questions[26].Config"
          />
        </div>
        <div class="col-12"></div>
        <div class="col-md-3 hide">
          <!-- work_other_country_code -->
          <doCountry
            autocomplete="off"
            v-model="page.Questions[27].Value"
            :value="page.Questions[27].Value"
            :id="page.Questions[27].QID"
            :config="page.Questions[27].Config"
            @getNewData="set2ndCountry"
          />
        </div>
        <div class="col-md-3 col-6" v-if="hasDKAddressContact()">
          <!-- Zip -->
          <DoZipCode
            v-model="page.Questions[28].Value"
            :value="page.Questions[28].Value"
            :id="page.Questions[28].QID"
            :config="page.Questions[28].Config"
            :options="page.Questions[28].Options"
            @input="setCity(28)"
          />
        </div>
        <div class="col-md-6" v-if="hasDKAddressContact()">
          <!-- City -->
          <DoZipCode
            v-model="page.Questions[29].Value"
            :value="page.Questions[29].Value"
            :id="page.Questions[29].QID"
            :config="page.Questions[29].Config"
            :options="page.Questions[29].Options"
            @input="setZip(29)"
          />
        </div>

        <div class="col-md-3 col-6" v-if="!hasDKAddressContact()">
          <!-- Zip -->
          <DoInput
            v-model="page.Questions[35].Value"
            :value="page.Questions[35].Value"
            :id="page.Questions[35].QID"
            :config="page.Questions[35].Config"
          />
        </div>
        <div class="col-md-6" v-if="!hasDKAddressContact()">
          <!-- City -->
          <DoInput
            v-model="page.Questions[36].Value"
            :value="page.Questions[36].Value"
            :id="page.Questions[36].QID"
            :config="page.Questions[36].Config"
          />
        </div>
        <div class="col-md-6">
          <!-- work_other_country -->
          <doSelect
            v-model="page.Questions[30].Value"
            :value="page.Questions[30].Value"
            :id="page.Questions[30].QID"
            :config="page.Questions[30].Config"
            :options="countryOptions"
            @input="set2ndCountryCode"
          />
        </div>
      </div>
    </AppFlowTransition>
  </div>
</template>
<script>
  import axios from 'axios';
  import AppFlowTransition from '@/components/base/AppFlowTransition';
  export default {
    inject: {
      $validator: '$validator',
    },
    components: {
      AppFlowTransition,
    },
    props: {
      page: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        countryOptions: [],
        countryList: [],
      };
    },
    created() {
      axios
        .get(this.$store.state.pageData.EndpointCountries)
        .then((response) => {
          this.countryList = response.data;
          this.countryOptions = [
            { Value: 0, Title: 'Vælg' },
            ...response.data.map((item) => {
              return {
                Value: item.name,
                Title: item.name,
              };
            }),
          ];
        });
    },
    methods: {
      resetWork(val) {
        if (val) {
          this.page.Questions[0].Value = '';
        } else {
          this.page.Questions[2].Value = '';
          this.page.Questions[3].Value = '';
          this.page.Questions[4].Value = '';
          this.page.Questions[5].Value = '';
          this.page.Questions[6].Value = '';
          this.page.Questions[7].Value = '';
          this.page.Questions[8].Value = '';
          this.page.Questions[9].Value = '';
          this.page.Questions[10].Value = '';
          this.page.Questions[11].Value = '';
          this.page.Questions[12].Value = '';
          this.page.Questions[13].Value = '';
        }
      },
      setCountry(country) {
        if (country) {
          this.page.Questions[12].Value = country;
        } else {
          this.page.Questions[12].Value = '';
        }
      },
      set2ndCountry(country) {
        if (country) {
          this.page.Questions[30].Value = country;
        } else {
          this.page.Questions[30].Value = '';
        }
      },
      setCountryCode(country) {
        if (country) {
          this.page.Questions[9].Value = this.countryList
            .filter(
              (item) => item.name.toUpperCase() === country.toUpperCase()
            )[0]
            .code.toUpperCase();
        } else {
          this.page.Questions[9].Value = '';
        }

        setTimeout(() => {
          this.$validator.validateAll();
        }, 100);
      },
      set2ndCountryCode(country) {
        if (country) {
          this.page.Questions[27].Value = this.countryList
            .filter(
              (item) => item.name.toUpperCase() === country.toUpperCase()
            )[0]
            .code.toUpperCase();
        } else {
          this.page.Questions[27].Value = '';
        }

        setTimeout(() => {
          this.$validator.validateAll();
        }, 100);
      },
      apiGetSelectOptions(changedInput) {
        this.$store.state.spinner = true;
        // Resets every field after the selected
        switch (changedInput) {
          case 'employment_places':
            this.page.Questions[16].Value = ''; // employment_form,
            this.page.Questions[17].Value = ''; // employment_category
            this.page.Questions[18].Value = ''; // employment_timeofweek
            this.page.Questions[19].Value = ''; // employment_union_department
            break;
          case 'employment_area':
            this.page.Questions[16].Value = ''; // employment_form,
            this.page.Questions[17].Value = ''; // employment_category
            this.page.Questions[19].Value = ''; // employment_union_department
            this.page.Questions[18].Value = ''; // employment_timeofweek
            break;
          case 'employment_form':
            this.page.Questions[17].Value = ''; // employment_category
            this.page.Questions[19].Value = ''; // employment_union_department
            this.page.Questions[18].Value = ''; // employment_timeofweek
            break;
          case 'employment_category':
            this.page.Questions[19].Value = ''; // employment_union_department
            this.page.Questions[18].Value = ''; // employment_timeofweek
            break;
          case 'employment_timeofweek':
            break;
        }
        const payload = {
          data: {
            EmploymentPlace:
              this.page?.Questions[0]?.Value?.OrganizationId?.toString() ??
              undefined,
            EmploymentArea: this.page.Questions[2].Value.toString(),
            EmploymentForm: this.page.Questions[16].Value.toString(),
            EmploymentCategory: this.page.Questions[17].Value.toString(),
            EmploymentUnionDepartment: this.page.Questions[19].Value.toString(),
          },
          endpoint: '/data/GetEmployment',
          component: this.page.Component,
        };
        this.$store.dispatch('getSelectOptions', payload);
      },
      setZip(e) {
        if (
          typeof this.page.Questions[e].Value !== 'string' &&
          Object.keys(this.page.Questions[e].Value).length &&
          typeof this.page.Questions[e].Value.city != 'undefined'
        ) {
          this.page.Questions[e - 1].Value =
            this.page.Questions[e].Value.zip.name;
        }
      },
      setCity(e) {
        if (
          typeof this.page.Questions[e].Value !== 'string' &&
          Object.keys(this.page.Questions[e].Value).length &&
          typeof this.page.Questions[e].Value.city != 'undefined'
        ) {
          this.page.Questions[e + 1].Value =
            this.page.Questions[e].Value.city.name;
        }
      },
      hasDKAddressContact() {
        if (this.page.Questions[30].Value != 'Danmark') {
          this.page.Questions[29].Value = '';
          this.page.Questions[28].Value = '';
        }
        return this.page.Questions[30].Value === 'Danmark';
      },
      hasDKAddressNoWork() {
        if (this.page.Questions[12].Value != 'Danmark') {
          this.page.Questions[10].Value = '';
          this.page.Questions[11].Value = '';
        }
        return this.page.Questions[12].Value === 'Danmark';
      },
    },
    mounted() {
      this.page.Questions[9].Value = 'DK';
      this.page.Questions[12].Value = 'Danmark';
      this.page.Questions[27].Value = 'DK';
      this.page.Questions[30].Value = 'Danmark';
    },
  };
</script>
<style lang="scss" scoped>
  .mrow {
    width: calc(50% - 24px);
    margin-left: 12px;
    @include media-breakpoint-down(sm) {
      width: auto;
    }
  }
  .lwmobile {
    width: calc(100% - 74px);
  }
  .cwmobile {
    width: 50px;
    margin-right: 24px;
  }
</style>

